import { createAsyncThunk } from '@reduxjs/toolkit';
import type { GetServerSidePropsContext } from 'next';

import type { ApiPointsFetchParamsType } from 'constants/apiPoints';

import doFetch from 'utils/doFetch';

const couponCheckThunk = createAsyncThunk(
  'products/couponCheck',
  async ({
    context,
    coupon_code,
    product_ids,
  }: ApiPointsFetchParamsType['couponCheck']['queryParams'] & {
    context?: GetServerSidePropsContext;
  }) => {
    const apiPointName = 'couponCheck';

    return await doFetch<typeof apiPointName>({
      apiPointName,
      context,
      queryParams: {
        coupon_code,
        product_ids,
      },
      body: null,
    });
  },
);

export default couponCheckThunk;
